import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useMapContext } from '../context/MapContext';
import L from 'leaflet';

const FeatureList = () => {
  const { t } = useTranslation();
  const { geojsonData, selectedFeature, selectFeature, mapRef } = useMapContext();
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredFeatures, setFilteredFeatures] = useState([]);
  
  // Update filtered features when geojsonData or searchTerm changes
  useEffect(() => {
    if (!geojsonData || !geojsonData.features) {
      setFilteredFeatures([]);
      return;
    }
    
    let features = [...geojsonData.features];
    
    // Sort features by DUN code
    features.sort((a, b) => {
      const codeA = a.properties.DUN_CODE || '';
      const codeB = b.properties.DUN_CODE || '';
      return codeA.localeCompare(codeB);
    });
    
    // Filter by search term
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      features = features.filter(feature => {
        const props = feature.properties;
        return (
          (props.DUN_NAME && props.DUN_NAME.toLowerCase().includes(term)) ||
          (props.DUN_CODE && props.DUN_CODE.toLowerCase().includes(term)) ||
          (props.PARLIAMENT && props.PARLIAMENT.toLowerCase().includes(term)) ||
          (props.PARLIAMENT_CODE && props.PARLIAMENT_CODE.toLowerCase().includes(term))
        );
      });
    }
    
    setFilteredFeatures(features);
  }, [geojsonData, searchTerm]);
  
  // Handle feature selection
  const handleSelectFeature = (feature) => {
    // In the React-Leaflet implementation, we don't have direct layer references
    // Instead, we'll create a unique ID based on feature properties
    const uniqueId = `${feature.properties.DUN_CODE || ''}_${feature.properties.DUN_NAME || ''}`;
    
    
    // Select the feature
    selectFeature(feature, uniqueId);
    
    // Find the feature on the map and zoom to it
    if (mapRef.current) {
      try {
        // Create a temporary layer to get bounds
        const tempLayer = L.geoJSON(feature);
        const bounds = tempLayer.getBounds();
        
        if (bounds.isValid()) {
          mapRef.current.fitBounds(bounds);
        }
      } catch (error) {
        console.error('Error focusing on feature:', error);
      }
    }
  };
  
  return (
    <div>
      <div className="search-box">
        <input
          type="text"
          placeholder={t('featureList.search')}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      
      <div className="feature-list">
        {filteredFeatures.length === 0 ? (
          <div className="feature-item">{t('featureList.noDunsFound')}</div>
        ) : (
          filteredFeatures.map((feature, index) => (
            <div
              key={index}
              className={`feature-item ${selectedFeature && selectedFeature.feature === feature ? 'selected' : ''}`}
              onClick={() => handleSelectFeature(feature)}
            >
              {feature.properties.DUN_NAME || 'Unnamed'} ({feature.properties.DUN_CODE || 'No Code'})
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default FeatureList;
